// Keep absent options absent so native defaults (including the bare profile avatar)
// survive. An explicit "false" must still reach the native bridge as a boolean.
export function bridgeBackgroundOptions(element) {
  const options = {}
  const sharesBackground = element.getAttribute("data-bridge-shares-background")
  const hidesSharedBackground = element.getAttribute("data-bridge-hides-shared-background")
    ?? element.getAttribute("data-hides-shared-background")

  if (sharesBackground !== null) {
    options.sharesBackground = sharesBackground === "true"
  }
  if (hidesSharedBackground !== null) {
    options.hidesSharedBackground = hidesSharedBackground === "true"
  }

  return options
}
